import { render, staticRenderFns } from "./DetailShare.vue?vue&type=template&id=64e5efe9&scoped=true&"
import script from "./DetailShare.vue?vue&type=script&lang=js&"
export * from "./DetailShare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e5efe9",
  null
  
)

export default component.exports